import mimeStartsWith from 'utils/mimeStartsWith';

/** RN / iOS voice notes often use .m4a; MIME may be missing or wrong (e.g. octet-stream). */
const AUDIO_FILENAME_EXT = /\.(m4a|mp3|mp2|mpeg|mpg|aac|ogg|opus|wav|webm|flac|caf|x-caf)(\?|#|$)/i;

/**
 * Effective MIME for playback when server sends generic or missing type.
 */
export function getAudioMimeTypeHint(attachment) {
  const direct =
    attachment?.mimeType ||
    attachment?.mime_type ||
    attachment?.meta?.mimeType ||
    attachment?.meta?.mime_type ||
    '';
  if (typeof direct === 'string' && direct.toLowerCase().startsWith('audio/')) {
    return direct;
  }
  const name = (attachment?.name || '').toLowerCase();
  if (name.endsWith('.m4a')) return 'audio/mp4';
  if (name.endsWith('.mp3') || name.endsWith('.mpeg') || name.endsWith('.mpg')) return 'audio/mpeg';
  if (name.endsWith('.aac')) return 'audio/aac';
  if (name.endsWith('.ogg') || name.endsWith('.opus')) return 'audio/ogg';
  if (name.endsWith('.webm')) return 'audio/webm';
  if (name.endsWith('.wav')) return 'audio/wav';
  if (name.endsWith('.flac')) return 'audio/flac';
  if (name.endsWith('.caf') || name.endsWith('.x-caf')) return 'audio/x-caf';
  return direct || 'audio/mpeg';
}

const isAudio = object => {
  if (mimeStartsWith(object, 'audio/')) {
    return true;
  }
  const metaMime = object?.meta?.mimeType || object?.meta?.mime_type;
  if (typeof metaMime === 'string' && metaMime.toLowerCase().startsWith('audio/')) {
    return true;
  }
  const name = object?.name || '';
  return AUDIO_FILENAME_EXT.test(name);
};

export default isAudio;
